/* eslint-disable no-undefined */
import merge from 'lodash/merge'

import * as ActionTypes from 'actions/forms'

// import {
//   FORM_ADD_TAG,
//   FORM_ADD_TAGS,
//   FORM_UPDATE_TAG,
//   FORM_CLEAR_FIELD,
//   FORM_DELETE_TAG,
//   FORM_DELETE_TAGS,
//   FORM_ERROR,
//   FORM_HAS_COMPLETED,
//   FORM_INIT,
//   FORM_RESET,
//   FORM_SUBMIT,
//   FORM_SUBMIT_CLEAR,
//   FORM_SUBMIT_COMPLETE,
//   FORM_UPDATE,
//   FORM_OPTIONS_UPDATE,
//   FORM_OPTIONS_COMPLETE,
// } from 'constants/actions'

const initialState = {}

const getValue = (field) => {
  if (field.type === 'switch' || field.type === 'checkbox') {
    return field.value || false
  } else if (field.multi === true || field.type === 'tagInput') {
    return []
  }
  return ''
}

const formStateObj = (data, field) => {
  const val = getValue(field)

  const obj = {
    error: '',
    focus: false,
    valid: true,
    value: data[field.name] || val,
  }

  // If field needs to make requests we add extra states to form field.
  if (field.requestOptions) {
    obj.options = field.options || []
    obj._isFetching = false
  }

  // Add selected Index state key for select boxes.
  if (field.type === 'select') { obj.selectedIndex = field.selectedIndex || -1 }

  return obj
}

const buildAndSetStateTree = (formFields, data) => {
  const form = {
    _hasCompleted: false,
    _isComplete: false,
    _isPosting: false,
  }

  formFields.forEach((field) => {
    if (field.elements) {
      field.elements.forEach((element) => {
        form[element.name] = formStateObj(data, element)
      })
    } else {
      form[field.name] = formStateObj(data, field)
    }
  })

  return form
}

export default function forms(state = initialState, action) {
  const errors = {}
  if (action.errors) {
    action.errors.forEach((obj) => {
      errors[obj.field] = {
        ...state[action.formName][obj.field],
        error: obj.error,
        valid: false,
      }
    })
  }

  switch (action.type) {
    case ActionTypes.FORM_INIT:
      return Object.assign({}, state, {
        [action.formName]: buildAndSetStateTree(action.formData.formFields, action.formData.data),
      })

    case ActionTypes.FORM_UPDATE:
      return merge({}, state, {
        [action.formName]: {
          [action.formData.field]: {
            ...action.formData.data,
          },
        },
      })

    case ActionTypes.FORM_CLEAR_FIELD: {
      let val = ''
      if ((Array.isArray(state[action.formName][action.fieldName].value))) {
        const len = state[action.formName][action.fieldName].value.length
        val = state[action.formName][action.fieldName].value
        val.splice(0, len)
      }

      return merge({}, state, {
        [action.formName]: {
          [action.fieldName]: {
            value: val,
          },
        },
      })
    }
    case ActionTypes.FORM_ADD_TAG: {
      const currValue = state[action.formName][action.formData.field].value
      currValue.push({
        id: currValue.length + 1,
        ...action.formData.data.value,
      })
      return merge({}, state, {
        [action.formName]: {
          [action.formData.field]: {
            ...action.formData.data,
            value: currValue,
          },
        },
      })
    }
    case ActionTypes.FORM_ADD_TAGS: {
      const currValue = state[action.formName][action.fieldName].value
      action.tags.forEach((tag) => {
        currValue.push({
          id: currValue.length + 1,
          label: tag.label,
          value: tag.value,
        })
      })
      const response = merge({}, state, {
        [action.formName]: {
          [action.fieldName]: {
            value: currValue,
          },
        },
      })

      return response
    }

    case ActionTypes.FORM_OPTIONS_UPDATE: {
      return merge({}, state, {
        [action.formName]: {
          [action.fieldName]: {
            _isFetching: true,
          },
        },
      })
    }

    case ActionTypes.FORM_OPTIONS_COMPLETE: {
      return merge({}, state, {
        [action.formName]: {
          [action.fieldName]: {
            lastQuery: action.lastQuery,
            options: action.options,
            _isFetching: false,
          },
        },
      })
    }

    case ActionTypes.FORM_UPDATE_TAG: {
      const currValue = state[action.formName][action.fieldName].value
      currValue[action.index].label = action.label

      return merge({}, state, {
        [action.formName]: {
          [action.fieldName]: {
            value: currValue,
          },
        },
      })
    }

    case ActionTypes.FORM_DELETE_TAG: {
      const tags = state[action.formName][action.fieldName].value
      tags.splice(action.index, 1)
      return merge({}, state, {
        [action.formName]: {
          [action.fieldName]: {
            value: tags,
          },
        },
      })
    }

    case ActionTypes.FORM_DELETE_TAGS: {
      const tags = state[action.formName][action.fieldName].value
      const forRemoval = action.tags
      const reducedTags = tags.reduce((prev, next) => {
        const check = forRemoval.filter(({ id }) => {
          return id === next.id
        })
        const arr = (!check.length) ? prev.concat(next) : prev
        return arr
      }, [])

      return Object.assign({}, state, {
        [action.formName]: {
          ...state[action.formName],
          [action.fieldName]: {
            value: reducedTags,
          },
        },
      })
    }

    case ActionTypes.FORM_ERROR:
      return merge({}, state, {
        [action.formName]: {
          ...errors,
          _hasCompleted: false,
          _isComplete: false,
          _isPosting: false,
        },
      })

    case ActionTypes.FORM_SUBMIT:
      return merge({}, state, {
        [action.formName]: {
          _hasCompleted: false,
          _isComplete: false,
          _isPosting: true,
        },
      })

    case ActionTypes.FORM_HAS_COMPLETED:
      return merge({}, state, {
        [action.formName]: {
          _hasCompleted: true,
          _isComplete: true,
          _isPosting: false,
        },
      })

    case ActionTypes.FORM_SUBMIT_COMPLETE:
      return merge({}, state, {
        [action.formName]: {
          _isComplete: true,
          _isPosting: false,
        },
      })

    case ActionTypes.FORM_SUBMIT_CLEAR:
      return merge({}, state, {
        [action.formName]: {
          _isComplete: false,
          _isPosting: false,
        },
      })

    case ActionTypes.FORM_RESET: {
      const resetKeys = state[action.formName]
      Object.keys(state[action.formName]).forEach((key) => {
        if (key.indexOf('_') < 0) {
          if ((Array.isArray(resetKeys[key].value))) {
            const len = resetKeys[key].value.length
            resetKeys[key].value.splice(0, len)
          } else if (typeof resetKeys[key].value === 'boolean') {
            // @TODO need to redo this! (Re: Create Conversation)
            // original: resetKeys[key].value = false
            resetKeys[key].value = action.truthyFlag && key === action.specialKey
          } else {
            resetKeys[key].value = ''
            // eslint-disable-next-line no-undefined
            if (resetKeys[key].selectedIndex !== undefined) {
              resetKeys[key].selectedIndex = -1
            }
          }
          resetKeys[key].valid = true
          resetKeys[key].error = ''
        }
      })
      return merge({}, state, {
        [action.formName]: {
          ...resetKeys,
          _hasCompleted: false,
          _isComplete: false,
          _isPosting: false,
        },
      })
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/forms.js